<script lang="ts" setup>
type OptionType = string | { id: string; title: string }

const props = defineProps({
  options: { type: Array as PropType<OptionType[]>, required: true },
  value: { type: String, default: '' },
  name: { type: String, required: true },
  placeholder: { type: String, required: true }
})

const emit = defineEmits(['handleClick'])

const active = ref(false)

const getTitle = (option: OptionType) => {
  if (typeof option === 'string') return option
  else return option.title
}

const getHeaderId = () => {
  return `form-select-header-${props.name}-${props.placeholder}`
}

const getTitleFromId = () => {
  const val = props.options.find((option: any) => {
    if (typeof option === 'string') return option === props.value
    else return option.id === props.value
  })

  if (!val) return ''
  else if (typeof val === 'string') return val
  else return val?.title
}

const getIdFromTitle = (title: string) => {
  const val = props.options.find((option: any) => {
    if (typeof option === 'string') return option === title
    else return option.title === title
  })

  if (!val) return ''
  else if (typeof val === 'string') return val
  else return val?.id
}

const getHeaderTitle = () => getTitleFromId() || props.placeholder

const selectInput = (e: Event) => {
  emit('handleClick', getIdFromTitle((e.target as HTMLInputElement).value || ''))
}

const checkSelected = (value: string, option: any) => {
  if (typeof option === 'string') return value === option
  else return value === option.id
}
</script>

<template>
  <div :class="`form-select ${active ? 'form-select-active' : ''}`">
    <select
      :id="getHeaderId()"
      :name="name"
      :value="value"
      @focus="active = true"
      @blur="active = false"
      @input="selectInput"
    >
      <option disabled :selected="value ? false : true">{{ placeholder }}</option>

      <option
        v-for="(option, i) in options"
        :key="`form-select-${name}-${placeholder}-${i}`"
        :selected="checkSelected(value, option)"
      >
        {{ getTitle(option) }}
      </option>
    </select>
    <div class="header">
      <span :class="value ? '' : 'placeholder'"> {{ getHeaderTitle() }} </span>
      <div class="header-chevron"><CommonIconChevron /></div>
    </div>
  </div>
</template>

<style lang="scss">
.form-select {
  position: relative;

  select {
    opacity: 0;
  }

  .header {
    position: absolute !important;
    top: 0;
    left: 0;
    z-index: 2;
    pointer-events: none;
    width: 100%;
    height: 100%;
    border: 1px solid var(--borderM2);
    padding: 0 15px;
    border-radius: 7px;
    font-size: 1rem;
    display: flex;
    align-items: center;
    text-align: left;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      display: block;
    }

    .placeholder {
      color: var(--textM2);
    }

    svg {
      height: 13px;
      width: 13px;
      fill: var(--textM2);
      transform: rotate(90deg);
    }
  }

  &-active {
    .header {
      border-color: var(--purple);
    }
  }
}
</style>
